import axios from "axios";
import { API_URL } from "../constants";
import { ProjectActivity } from "./project-activities.service";

export type ProjectHistoryKind =
  | "activity"
  | "note"
  | "email"
  | "file"
  | "changelog";

export type ProjectHistoryUser = { id: string; name: string | null };

export type ProjectFocusItem = {
  id: string;
  kind: "activity" | "due_date";
  at: number;
  overdue: boolean;
  data: Record<string, unknown>;
};

export type ProjectHistoryItem = {
  id: string;
  kind: ProjectHistoryKind;
  at: number;
  user: ProjectHistoryUser | null;
  data: Record<string, unknown>;
};

export type ProjectHistoryCounts = {
  all: number;
  activity: number;
  note: number;
  email: number;
  file: number;
  changelog: number;
};

export type ProjectHistoryResponse = {
  focus: ProjectFocusItem[];
  history: ProjectHistoryItem[];
  counts: ProjectHistoryCounts;
};

export async function fetchProjectHistory(
  companyId: string,
  projectId: string
): Promise<ProjectHistoryResponse> {
  const res = await axios.get(
    `${API_URL}/${companyId}/projects/${projectId}/history`
  );
  return res.data;
}

export type { ProjectActivity };
